export class ComplementData {
  customField: CustomField;
  customFieldId: number;
  defaultFormValue: string;
  description: string;
  id: number;
  listItems: ListItemDTO[];
  name: string;
  natureId: number;
  utilisable: boolean | number;
  constructor(data?) {
    if (data) {
      Object.assign(this, data);
      if (data.listItems?.length > 0) {
        this.listItems = this.listItems.map((item) => {
          item = new ListItemDTO(item);
          return item;
        });
      }
    } else {
      this.customField = new CustomField();
      this.customFieldId = null;
      this.defaultFormValue = '';
      this.description = '';
      this.id = null;
      this.name = '';
      this.natureId = null;
      this.listItems = [];
    }
    if (this.utilisable === 1) {
      this.utilisable = true;
    } else {
      this.utilisable = false;
    }
  }
}

export class CustomField {
  id: number;
  name: string;
  type: string;
  constructor(data?) {
    this.id = data?.id ? data.id : null;
    this.name = data?.name ? data.name : '';
    this.type = data?.type ? data.type : '';
  }
}

export class ListItemDTO {
  customFieldId: number;
  description: string;
  id: number;
  name: string;
  utilisable: boolean | number;
  constructor(data?) {
    Object.assign(this, data);
    if (data) {
      this.utilisable = data.utilisable ? true : false;
    } else {
      this.utilisable = true;
    }
  }
}
